import script from "./AddTopicForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddTopicForm.vue?vue&type=script&setup=true&lang=js"

import "./AddTopicForm.vue?vue&type=style&index=0&id=361ad8d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-361ad8d6"]])

export default __exports__